import React from 'react';
import { withRouter } from 'react-router-dom';

import './events.less';

const Events = () => {
  return (
    <section className="cdo-section cdo-section-events">
      <h2>EVENTOS</h2>
    </section>
  );
};

export default withRouter(Events);
